const ceoQueue = {
  waiting: "В очереди",
  inProgress: "В работе",
  forReview: "На проверке",
  empty: "Очередь пуста",
  openInNotion: "Открыть в Notion",
  queueTab: "Очередь",
  updatesTab: "Обновления",
  noUpdates: "Нет новых обновлений",
  readyForReview: "Готово к проверке",
  questionsForYou: "Claude спрашивает",
} as const;
export default ceoQueue;
